import { render, staticRenderFns } from "./AvailableLaboursMain.vue?vue&type=template&id=18d61f5f"
import script from "./AvailableLaboursMain.vue?vue&type=script&lang=js"
export * from "./AvailableLaboursMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports